import {JsonAdapter} from "../helpers/JsonAdapter";
import {Vacancy} from "./Vacancy";
import {UserProfile} from "./UserProfile";
import {Organisation} from "./Organisation";
import {Application} from "./Application";
import {Portfolio} from "./Portfolio";
import {Message} from "./Message";
import {User} from "./User";
import {InterestAlert} from "./InterestAlert";

export class Conversation {

  static readonly TYPE_EOI = 'eoi';
  static readonly TYPE_OTHER = 'other';

  id: string = "";
  user!: User;
  name: string = "";
  title: string = "";
  conversation_type: string = "";
  initiated_by: string = "";
  messages: Message[] = [];
  organisation?: Organisation;
  participants: User[] = [];
  related_to_application?: Application;
  related_to_eoi?: InterestAlert;
  related_to_portfolio?: Portfolio;
  related_to_vacancy: Vacancy[] = [];
  created_at: string = "";
  _current_user_meta?: any;

  constructor() {
    console.log("created Conversation");
  }


  static create(object:any): Conversation {
    const item = JsonAdapter.fill(new Conversation(), object);

    if(object.user) {
      item.user = User.create(object.user);
    }

    if(object.participants) {
      item.participants = User.createMultiple(object.participants);
    }


    if(object.related_to_eoi) {
      item.related_to_eoi = object.related_to_eoi;
    }

    if(object.related_to_portfolio) {
      item.related_to_portfolio = object.related_to_portfolio;
    }

    if(object.related_to_application) {
      item.related_to_application = object.related_to_application;
    }

    if(object.related_to_vacancy) {
      item.related_to_vacancy = Vacancy.createMultiple(object.related_to_vacancy);
    }

    if(object._current_user_meta) {
      item._current_user_meta = object._current_user_meta;
    }

    return item;
  }

  static createMultiple(objects: Conversation[]): Conversation[] {
    const items = [];
    for (let i = 0; i < objects.length; i++) {
      items.push(Conversation.create(objects[i]));
    }
    return items;
  }

  displayName(currentUserProfileId = "") {
    return this.participants.filter(item => item.profile?.id != currentUserProfileId).map(item => item.fullname).join(', ');
  }

  get topic() {
    if(this.related_to_application) {
      return "Job Application on" + this.related_to_application?.vacancy?.job_title;
    } else if(this.related_to_portfolio) {
      return this.participants.find(item => item.roles.includes('student'))?.name + "'s Portfolio approval";
    } else if(this.related_to_vacancy.length > 0) {
      return "Interest Alert on " + this.related_to_vacancy[0].job_title;
    }

    return "General";
  }

  hasNewMessage() {
    return this._current_user_meta && this._current_user_meta.unread_messages_count > 0;
  }

  get newMessageCount() {
    return (this._current_user_meta && this._current_user_meta.unread_messages_count) || 0
  }

  isLeavable() {
    if(this.related_to_application?.id || this.related_to_vacancy.length > 0  || this.related_to_portfolio?.id) {
      return false;
    }

    return true;
  }

  getEOITargetIndividual() {
    return this.participants.find(item => item.roles.includes('individual'));
  }
}
